import { DataSource } from '@angular/cdk/collections';
import { Component, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';
import { JsonPipe } from '@angular/common';
import { FormService } from 'src/app/shared/form.service';
import { FormViewModel } from 'src/app/shared/models/FormModels';
import { FormAdminCardComponent } from '../form-admin-card/form-admin-card.component';

import { of } from 'rxjs';
import { MatIconModule } from '@angular/material/icon';

@Component({
    selector: 'app-org-forms',
  imports: [FormAdminCardComponent, RouterModule, MatIconModule],
    templateUrl: './org-forms.component.html',
    styleUrls: ['./org-forms.component.css']
})
export class OrgFormsComponent implements OnInit {
  forms: FormViewModel[];
  columnsToDisplay = ['Name', 'LatestVersion', 'Description', 'PlayerEnabled', 'Actions'];
  //columnsToDisplay = ['Name', 'LatestVersion', 'Description'];
  dataSource: any;
  constructor(private formService: FormService) { }

  ngOnInit(): void {
    this.getForms();
    //console.log(this.dataSource);
  }

  getForms(){
    this.formService.getForms().subscribe(forms=>{
      //console.log(forms);
      this.forms = forms as FormViewModel[];
      this.dataSource = forms as FormViewModel[];
    });
  }

}
